/* global debounce */

if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.cachedResults = {};
      this.input = this.querySelector('.js-search-input');
      this.productTypeSelect = this.querySelector('.js-search-product-types');
      this.productTypeInput = document.getElementById('product_type_input');
      this.resetBtn = this.querySelector('.js-search-reset');
      this.results = this.querySelector('.js-search-results');
      this.overlay = this.querySelector('.js-search-overlay');
      this.statusEl = this.querySelector('.js-search-status');
      this.loadingText = this.getAttribute('data-loading-text');
      this.addListeners();
      this._searchForm = this.querySelector('form');
      this.closeRecomsBtn = this.querySelector('.hr-close-recoms');
      this.closeBtn = this.querySelector('.hr-close-btn:not(.hr-close-recoms)');
      this.categoriesExpanded = false;

      document.querySelectorAll('.hr-filters-toggle-mobile').forEach((btn) => {
        btn.addEventListener('click', this._toggleMobileFilters.bind(this));
      });
      document.querySelectorAll('.hr-search-title-mobile').forEach((title) => {
        title.addEventListener('click', () => {
          let dataToggle = title.getAttribute('data-toggle');
          document.querySelectorAll('.hr-toggle-mobile, .hr-search-title-mobile').forEach((toggle) => {
            toggle.classList.remove('active');
          });
          title.classList.toggle('active');
          document.querySelectorAll(`.hr-toggle-mobile[data-toggle="${dataToggle}"]`).forEach((toggle) => {
            toggle.classList.add('active');
          });
        });
      });
      document.querySelector('.js-search-input[name="q"]').addEventListener("keydown", function(e) {
        if (e.keyCode == 13) {
          this.blur();
        }
      });

      // Add event listener for mobile category show more button
      const self = this;
      document.addEventListener('click', (e) => {
        if (e.target.closest('.hr-categories-show-more-btn')) {
          self._toggleMobileCategories();
        }
      });
    }

    /**
     * Triggers when the web component is removed from the DOM
     */
    disconnectedCallback() {
      this.close();
    }

    addListeners() {
      this.input.addEventListener('focus', this.handleFocus.bind(this));
      this.input.addEventListener('input', debounce(this.handleInput.bind(this), 300));
      if (this.productTypeSelect) {
        this.productTypeSelect.addEventListener('change', this.handleProductTypeChange.bind(this));
      }
      this.querySelector('.search').addEventListener('submit', this.handleSubmit.bind(this));
    }

    /**
     * Gets the value of the search input field.
     * @returns {string}
     */
    getQuery() {
      return this.input.value.trim();
    }

    /**
     * Handles search form submit.
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      // if (
      //   !this.getQuery().length
      //   || this.querySelector('.predictive-search__item[aria-selected="true"]:not(.js-submit)')
      // ) {
      //   evt.preventDefault();
      // }
      evt.preventDefault();
      this.input.setAttribute('value', this.input.value);

      const searchTerm = this.getQuery();

      // if (!searchTerm.length) {
      //   this.close();
      //   return;
      // }

      this.getResults(searchTerm);
    }

    /**
     * Handles 'input' events on the search field.
     */
    handleInput() {
      // autocomplete=off prevents browser from restoring value after using back button in Safari
      this.input.setAttribute('value', this.input.value);

      const searchTerm = this.getQuery();

      // if (!searchTerm.length) {
      //   this.close();
      //   return;
      // }

      this._abortController?.abort();
      this._abortController = new AbortController();
      this.getResults(searchTerm);
    }

    /**
     * Handles a change of product type
     * @param {object} evt - Event object.
     */
    handleProductTypeChange(evt) {
      this.productTypeInput.value = evt.detail.selectedValue;
      const query = this.getQuery();
      if (query.length > 0) {
        this.getResults(query);
      }
    }

    /**
     * Handles 'focus' events on the search field.
     */
    handleFocus() {
      const searchTerm = this.getQuery();
      if (this.getAttribute('results') === 'true') {
        this.open();
      } else {
        this.getResults(searchTerm);
      }
    }

    /**
     * Handles 'keydown' events on the custom element.
     * @param {object} evt - Event object.
     */
    handleKeydown(evt) {
      // Let tabs script handle keydown events on the tab buttons.
      if (evt.target.matches('.tablist__tab')) return;

      switch (evt.key) {
        case 'ArrowUp':
        case 'ArrowDown':
          evt.preventDefault();

          if (this.hasAttribute('open')) {
            this.handleResultsNav(evt.key);
          }
          break;

        case 'Enter':
          this.selectOption();
          break;

        case 'Escape':
          this.close();
          break;

        // no default
      }
    }

    /**
     * Handles 'keyup' events on the custom element.
     */
    handleKeyup() {
      // If search field is empty after key press, close the results.
      // if (!this.getQuery().length) this.close();
      // Customized. We dont need this because we want to keep the results open
    }

    /**
     * Handles keyboard navigation of the results.
     * @param {string} key - Key pressed.
     */
    handleResultsNav(key) {
      const selectedResult = this.querySelector(
        '[role="tabpanel"]:not([hidden]) [aria-selected="true"]'
      );
      const allResults = this.querySelectorAll(
        '[role="tabpanel"]:not([hidden]) .predictive-search__item'
      );
      let resultToSelect = allResults[0];

      if (key === 'ArrowUp') {
        if (!selectedResult) return;

        // Select the next result up or the last one if we've reached the top of the list.
        resultToSelect = selectedResult.previousElementSibling || allResults[allResults.length - 1];
      } else if (key === 'ArrowDown') {
        if (selectedResult) {
          // Select the next result down or the first one if we've reached the bottom of the list.
          resultToSelect = selectedResult.nextElementSibling || allResults[0];
        }
      }

      this.statusEl.textContent = '';

      if (resultToSelect) {
        // If the selected item didn't change, do nothing.
        if (resultToSelect === selectedResult) return;

        resultToSelect.setAttribute('aria-selected', 'true');
        if (selectedResult) selectedResult.setAttribute('aria-selected', 'false');

        this.setLiveRegionText(resultToSelect.textContent);
        this.input.setAttribute('aria-activedescendant', resultToSelect.id);
      }
    }

    /**
     * Selects a result
     */
    selectOption() {
      const selectedResult = this.querySelector('[aria-selected="true"] > .js-search-link');
      if (selectedResult) selectedResult.click();
    }

    /**
     * Gets the results for a search term.
     * @param {string} searchTerm - Search query.
     */
    async getResults(searchTerm, searchType = '') {
      if (window.theme.settings.helloretailUuid != '') {
        this.searchTerm = searchTerm;
        if (!this.page || !this._isFetchingMoreProducts) {
          this.page = 1;
        }
        let form = this._searchForm;
        this.apiKey = window.theme.settings.helloretailSearchKey;
        let selector = {
          productListWrapper: '.hr-products .hr-product-list',
          categoriesWrapper: '.hr-categories',
          filtersWrapper: '.hr-filters',
          productSke: '.hr-product-grid-skeleton product-card',
          collectionSke: '.hr-collection-skeleton li',
          filterSke: '.hr-filter-skeleton li',
          priceSke: '.hr-price-skeleton',
          productEmpty: '.hr-products-empty',
          categoryEmpty: '.hr-categories-empty',
          categoryShowMoreWrapper: '.hr-categories-show-more',
          categoryShowMoreBtn: '.hr-categories-show-more-btn',
          showMoreText: '.hr-show-more-text',
          showLessText: '.hr-show-less-text',
        }
        this.selector = selector;
    
        // only show loading if the query is different from the previous one
        let shouldShowTransition = true;

        if (this.oldQuery && this.oldQuery == searchTerm) {
          shouldShowTransition = false;
        }
        if (shouldShowTransition) {
          this.page = 1; // reset page
          // await this._transitionToSlot('loading');
          // scroll .predictive-search__scroller to top
          if (this.querySelector('[data-predictive-search] .predictive-search__scroller')) {
            this.querySelector('[data-predictive-search] .predictive-search__scroller').scrollTop = 0;
          }
          // this.querySelector('[data-predictive-search] .predictive-search__scroller').
        }
        this.oldQuery = searchTerm;
        this.currentSearchSort = [];
    
        // custom search from HelloRetail
        let queryParams = new URLSearchParams({
          q: searchTerm,
          trackingUserId: window.helloRetailTrackingUserId ? window.helloRetailTrackingUserId : '',
          product_count: 20,
          format: 'json',
          product_start: (this.page - 1) * 20,
          return_filters: true,
          category_count: 40
        });
    
        // loop all filter item and add selected filter to query params
        if (!shouldShowTransition) {
          form.querySelectorAll('.hr-filter-dropdown-content li.selected:not(.hr-search-sort-option)').forEach(function (item) {
            queryParams.append('filters[]', item.getAttribute('data-query'));
          });

          // add sort param to query params
          if (form.querySelector('.hr-search-sort-option.selected')) {
            let sortOption = form.querySelector('.hr-search-sort-option.selected').getAttribute('data-value');
            if (sortOption != 'most-popular') {
              queryParams.append('sorting[]', sortOption);
              this.currentSearchSort.push(sortOption);
              if (sortOption == 'extraData.PIMsort asc' || sortOption == 'created desc') {
                queryParams.append('sorting[]', 'extraData.sortOnTitle asc');
                this.currentSearchSort.push('extraData.sortOnTitle asc');
              }
            }
          }
        }
    
        // add price param to query params
        if (!shouldShowTransition) {
          if (form.querySelector('.hr-filter-dropdown-content .field-price-min') && form.querySelector('.hr-filter-dropdown-content .field-price-max')) {
            let priceMin = parseInt(form.querySelector('.field-price-min').getAttribute('min'));
            let priceMax = parseInt(form.querySelector('.field-price-max').getAttribute('max'));
            let priceMinSelected = form.querySelector('.field-price-min').value;
            let priceMaxSelected = form.querySelector('.field-price-max').value;
            if (priceMinSelected > priceMin || priceMaxSelected < priceMax) {
              queryParams.append('filters[]', `price:${priceMinSelected},${priceMaxSelected}`);
            }
          }
        }

        try {
          let response = {}
          let isShowingRecoms = false;
          if ((searchTerm === '' || searchType == 'recoms') && window.theme.settings.helloretailSearchRecomsKey != '') {
            isShowingRecoms = true;
            let params = {
              'websiteUuid': window.theme.settings.helloretailUuid,
              'trackingUserId': window.helloRetailTrackingUserId ? window.helloRetailTrackingUserId : '',
              'requests': [
                {
                  'key': window.theme.settings.helloretailSearchRecomsKey,
                  'format': 'json',
                  //'fields': fieldsArray, // ignore this for now to make it return all data needed
                  'context': {
                    'urls': [window.location.href]
                  }
                }
              ]
            };
            response = await fetch('https://core.helloretail.com/serve/recoms', {
              method: 'POST',
              credentials: 'include', // use this to send the cookies along with the request
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(params)
            });
          } else {
            this.querySelector('.search__submit').classList.add('loading');
            //response = await fetch(`https://core.helloretail.com/api/v1/search/partnerSearch?key=${this.apiKey}&${queryParams}`);

            response = await fetch(`https://core.helloretail.com/api/v1/search/partnerSearch?key=${this.apiKey}&${queryParams}`, {
              method: 'POST',
              credentials: 'include', // use this to send the cookies along with the request
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
            });
          }

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
    
          const data = await response.json();
          this.data = data;

          if (isShowingRecoms) {
            this._renderSearchRecomProducts();
            if (searchTerm === '') {
              form.querySelector('.hello-retail-search-results .hr-inner').classList.add('hidden');
              form.querySelector('.hello-retail-search-results .hr-inner-recoms').classList.remove('hidden');
              form.querySelector('.hello-retail-search-results .hr-products-empty-recoms').classList.add('hidden');
            } else {
              form.querySelector('.hello-retail-search-results .hr-inner').classList.remove('hidden');
              form.querySelector('.hello-retail-search-results .hr-inner-recoms').classList.add('hidden');
              form.querySelector('.hello-retail-search-results .hr-products-empty-recoms').classList.remove('hidden');
            }
          } else {
            form.querySelector('.hello-retail-search-results .hr-inner').classList.remove('hidden');
            form.querySelector('.hello-retail-search-results .hr-inner-recoms').classList.add('hidden');
            form.querySelector('.hello-retail-search-results .hr-products-empty-recoms').classList.add('hidden');
            form.querySelector('.hr-price-submit').classList.remove('loading');
      
            // 1. Get the product list from JSON data, then show on search grid
            this._renderSearchProducts();
      
            // 2. Iterate through categories and create list on left side
            let categories = data.categories;
            let categoriesWrapper = form.querySelector(selector.categoriesWrapper);
            let showMoreWrapper = form.querySelector(selector.categoryShowMoreWrapper);
            categoriesWrapper.innerHTML = '';

            // Reset mobile categories state for new search
            this.categoriesExpanded = false;

            let countCategories = 0;
            let isMobile = window.innerWidth < 768;
            
            // Debug logging
            console.log('Rendering categories, isMobile:', isMobile);
            console.log('Categories count:', categories ? categories.length : 0);
            
            if (categories && categories.length) {
              form.querySelector(selector.categoryEmpty).classList.add('hidden');
              categories.forEach((category, index) => {
                if (countCategories > 10) {
                  return;
                }
                let shouldShow = true;
                if (window.theme.settings.helloretailHideCollectionFromSearch) {
                  let excludeCollections = window.theme.settings.helloretailHideCollectionFromSearch.split(',');
                  excludeCollections.forEach(function (exclCollection) {
                    if (exclCollection.indexOf('*') == 0) {
                      let exclCollectionRegex = exclCollection.replace('*', '');
                      if (category.title.toLowerCase().indexOf(exclCollectionRegex.toLowerCase()) > -1) {
                        shouldShow = false;
                      }
                    } else {
                      if (exclCollection.toLowerCase() == category.title.toLowerCase()) {
                        shouldShow = false;
                      }
                    }
                  });
                }
                if (shouldShow) {
                  let categorySke = form.querySelector(selector.collectionSke).cloneNode(true);
                  categorySke.querySelector('a').innerText = category.title;
                  categorySke.querySelector('a').setAttribute('href', category.url);
                  
                  // On mobile, hide categories beyond the first 4
                  if (isMobile && countCategories >= 4) {
                    console.log(`Hiding category ${countCategories} on initial render:`, category.title);
                    categorySke.classList.add('hidden');
                  }
                  
                  categoriesWrapper.appendChild(categorySke);
                  countCategories++;
                }
              });

              console.log('Total categories rendered:', countCategories);

              // Show/hide the "Show more" button based on mobile and number of categories
              if (isMobile && countCategories > 4) {
                console.log('Showing "Show more" button');
                showMoreWrapper.classList.remove('hidden');
                // Reset button text to "Show more"
                form.querySelector(selector.showMoreText).classList.remove('hidden');
                form.querySelector(selector.showLessText).classList.add('hidden');
              } else {
                console.log('Hiding "Show more" button');
                showMoreWrapper.classList.add('hidden');
              }

              if (countCategories == 0) {
                this._showSearchArea(this._searchForm, '.hr-categories-empty')
              }
            } else {
              showMoreWrapper.classList.add('hidden');
              this._showSearchArea(this._searchForm, '.hr-categories-empty')
            }
      
            // 3. render filters on top of product grid
            this._renderSearchFilters();
          }

          this._isFetchingMoreProducts = false;
          // return this._transitionToSlot("results");
        } catch (e) {
          // Handle errors
          console.error(e);
          this._isFetchingMoreProducts = false;
        } finally {
          this.querySelector('.search__submit').classList.remove('loading');
          this.querySelector('.hello-retail-search-results')?.classList.remove('hidden');
          this.setAttribute('results', true);
          this.open();
        }
      } else {
        this.setLiveRegionLoadingState();

        const searchTypes = [];
        if (theme.settings.pSearchShowProducts) searchTypes.push('product');
        if (theme.settings.pSearchShowCollections) searchTypes.push('collection');
        if (theme.settings.pSearchShowPages) searchTypes.push('page');
        if (theme.settings.pSearchShowArticles) searchTypes.push('article');
        if (theme.settings.pSearchShowSuggestions) searchTypes.push('query');

        let searchFields = 'title,product_type,variants.title,vendor';
        if (theme.settings.pSearchIncludeSkus) searchFields += ',variants.sku';
        if (theme.settings.pSearchIncludeTags) searchFields += ',tag';

        let searchParams = '';
        if (this.productTypeInput && this.productTypeInput.value !== '') {
          searchParams = `q=product_type:${encodeURIComponent(this.productTypeInput.value)} AND ${encodeURIComponent(searchTerm)}`;
        } else {
          searchParams = `q=${encodeURIComponent(searchTerm)}`;
        }

        searchParams += `&${encodeURIComponent('resources[type]')}=${searchTypes.join()}`;
        searchParams += `&${encodeURIComponent('resources[limit]')}=${theme.settings.pSearchLimit}`;
        searchParams += `&${encodeURIComponent('resources[limit_scope]')}=${
          theme.settings.pSearchLimitScope
        }`;
        searchParams += `&${encodeURIComponent('resources[options][fields]')}=${searchFields}`;
        searchParams += '&section_id=predictive-search';

        const queryKey = searchParams.replace(' ', '-').toLowerCase();
        if (this.cachedResults[queryKey]) {
          this.renderResults(this.cachedResults[queryKey]);
          return;
        }

        try {
          const response = await fetch(`${theme.routes.predictiveSearch}?${searchParams}`);
          if (!response.ok) throw new Error(response.status);

          const tmpl = document.createElement('template');
          tmpl.innerHTML = await response.text();

          const resultsEl = tmpl.content.querySelector('#shopify-section-predictive-search');
          const resultsMarkup = resultsEl.innerHTML.replace(/psearch/g, this.input.id);

          this.cachedResults[queryKey] = resultsMarkup;
          this.renderResults(resultsMarkup);
        } catch (error) {
          this.close();
          throw error;
        }
      }
    }

    _showSearchArea(form, selector) {
      form.querySelector(selector).classList.remove('hidden');
      // switch to Product tab
      form.querySelector('.hr-search-title-mobile[data-toggle="left"]')?.classList.remove('active');
      form.querySelector('.hr-search-title-mobile[data-toggle="right"]')?.classList.add('active');
  
      form.querySelector('.hr-toggle-mobile[data-toggle="left"]')?.classList.remove('active');
      form.querySelector('.hr-toggle-mobile[data-toggle="right"]')?.classList.add('active');
    }

    /**
     * Render the search product results from Hello Retail
     */
    async _renderSearchProducts() {
      let products = this.data.result;
      this.numberOfPage = Math.ceil(this.data.product_results / 20);
      let form = this._searchForm;
      let selector = this.selector;
      let productListWrapper = form.querySelector(selector.productListWrapper);
      let self = this;

      if (products && products.length) {
        // hide empty message
        form.querySelector(selector.productEmpty).classList.add('hidden');
        form.querySelector('.hr-filters-toggle-mobile')?.classList.remove('hidden');

        // show product list wrapper
        if (this.page == 1) {
          productListWrapper.innerHTML = '';
        }
        productListWrapper.classList.remove('hidden');

        // Iterate through products and add them to the list
        products.forEach(function(product) {
          let productSke = self.renderProductItem(product);
          let productLi = document.createElement('li');
          productLi.appendChild(productSke);
          productListWrapper.appendChild(productLi);
        });

        // Load more products when scroll to end of grid. Set a timeout to prevent wrong client height
        let container = form.querySelector('[data-predictive-search] .predictive-search__scroller');
        let containerRight = form.querySelector('[data-predictive-search] .hr-right');
        setTimeout(() => {
          if (!container.classList.contains('loadmore-binded')) {
            container.addEventListener('scroll', () => {
              if (this.searchTerm !== '') {
                const scrollPosition = container.scrollTop + container.clientHeight;
                const scrollHeight = containerRight.scrollHeight;
                // Check if user has scrolled to the bottom
                if (scrollPosition >= scrollHeight && !this._isFetchingMoreProducts) {
                  if (this.page < this.numberOfPage) {
                    this._isFetchingMoreProducts = true;
                    this.page++;
                    this.getResults(this.searchTerm);
                  }
                }
              }
            });
            container.classList.add('loadmore-binded');
          }
        }, 300);
      } else {
        // show empty message
        form.querySelector(selector.productEmpty).classList.remove('hidden');
        // hide product list wrapper
        productListWrapper.classList.add('hidden');
        form.querySelector('.hr-filters-toggle-mobile')?.classList.add('hidden');
        this.getResults(this.searchTerm, 'recoms');
      }
    }

    async _renderSearchRecomProducts() {
      let content = this.data;
      let self = this;
      if (content.responses && content.responses[0] && content.responses[0].products && content.responses[0].products.length) {
        const products = content.responses[0].products;
        let form = this._searchForm;
        let productListWrapper = form.querySelector('.hr-recoms-products .hr-product-list');
        if (self.searchTerm != '') {
          productListWrapper = form.querySelector('.hr-products-empty-recoms-products .hr-product-list');
        }

        productListWrapper.innerHTML = '';
        products.forEach(function(product) {
          let productSke = self.renderProductItem(product);
          let productLi = document.createElement('li');
          productLi.appendChild(productSke);
          productListWrapper.appendChild(productLi);
        });
      }
    }

    renderProductItem(product) {
      let self = this;
      let form = this._searchForm;
      let selector = this.selector;
      let currentDate = new Date();
      let imageSize = 560;
      if (window.innerWidth < 768) {
        imageSize = 370;
      }

      let productSke = '';
      if (product.isBanner) {
        productSke = this.querySelector(selector.productSke).cloneNode(true);
      
        var bannerHTML = '<div class="hr-banner">';
        bannerHTML += '<a href="' + product.url + '" title="' + product.title + '">';

        var searchDesktopImg = null;
        var searchMobileImg = null;
        if (product.bannerImages.searchDesktop) {
          searchDesktopImg = product.bannerImages.searchDesktop;
          searchMobileImg = product.bannerImages.searchDesktop;
        }
        if (product.bannerImages[" searchMobile"]) {
          searchMobileImg = product.bannerImages[" searchMobile"];
        }
        if (searchDesktopImg) {
          bannerHTML += '<img class="desktop-only" src="' + searchDesktopImg.url + '" alt="' + searchDesktopImg.altText + '" width="' + searchDesktopImg.width + '" height="' + searchDesktopImg.height + '"/>'
        }
        if (searchMobileImg) {
          bannerHTML += '<img class="mobile-only" src="' + searchMobileImg.url + '" alt="' + searchMobileImg.altText + '" width="' + searchMobileImg.width + '" height="' + searchMobileImg.height + '"/>'
        }
        
        bannerHTML += '</a>';
        bannerHTML += '</div>';

        productSke.innerHTML = bannerHTML;
      } else {
        productSke = form.querySelector(selector.productSke).cloneNode(true);
        var productUrl = product.url;
        if (productUrl.indexOf('luksusbaby.no') > -1) {
          productUrl = productUrl.replace('luksusbaby.no', window.location.host);
        } else if (productUrl.indexOf('luksusbaby.dk') > -1) {
          productUrl = productUrl.replace('luksusbaby.dk', window.location.host);
        }

        let imageHtml = `<img src="${self.modifyImageUrl(product.imgUrl, imageSize)}" alt="${product.title}" class="img-fit card__main-image">`;
        let secondImage = product.imgUrl;
        if (product.extraData && product.extraData.hoverImage) {
          secondImage = product.extraData.hoverImage;
        }
        imageHtml += `<img src="${self.modifyImageUrl(secondImage, imageSize)}" alt="${product.title}" class="img-fit card__hover-image" fetchpriority="low">`;
        productSke.querySelector('.card__media > a').innerHTML = imageHtml;

        productSke.querySelector('.card__media a').setAttribute('href', productUrl);
        productSke.querySelector('.card__title a').innerText = product.title;
        productSke.querySelector('.card__title a').setAttribute('href', productUrl);

        var price = parseFloat(product.extraData.feedPrice)
        var compareAtPrice = parseFloat(product.extraData.feedCompareAtPrice)

        let priceFormatted = self.formatMoney(price * 100, window.theme.settings.moneyFormat);
        if (product.extraData.isFromPrice == 'true') {
          priceFormatted = window.theme.strings.fromPrice + ' ' + priceFormatted;
        }

        let compareAtPriceFormatted = self.formatMoney(compareAtPrice * 100, window.theme.settings.moneyFormat);
        productSke.querySelector('.price__current').innerText = priceFormatted;
        if (price < compareAtPrice) {
          productSke.querySelector('.price').classList.add('price--on-sale');
          productSke.querySelector('.price__was').innerText = compareAtPriceFormatted;

          let salePercent = Math.round((compareAtPrice - price) / compareAtPrice * 100);
          if (salePercent > 0 && productSke.querySelector('.badge--on-sale')) {
            productSke.querySelector('.badge--on-sale .badge-text').innerText += ` ${salePercent}%`;
            productSke.querySelector('.badge--on-sale').classList.remove('hidden');
          }
        }

        if (!product.inStock && productSke.querySelector('.badge--sold-out')) {
          productSke.querySelector('.badge--sold-out').classList.remove('hidden');
        }

        // add new badge base on published date
        if (productSke.querySelector('.badge--new')) {
          let publishedDate = product.extraData.publishedAt // "2022-02-04T10:53:00+01:00"
          // check if publishedDate < 30 days ago
          let publishedDateObj = new Date(publishedDate);
          let diffTime = Math.abs(currentDate - publishedDateObj);
          let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          if (diffDays < 30) {
            productSke.querySelector('.badge--new').classList.remove('hidden');
          }
        }

        if (product.extraDataList && product.extraDataList.badges && product.extraDataList.badges.length && productSke.querySelector('.badge--custom')) {
          // productSke.querySelector('.badge--custom .badge-text').innerText = product.extraDataList.badges[0];
          // productSke.querySelector('.badge--custom').classList.remove('hidden');
          let badgeArr = [];
          product.extraDataList.badges.forEach(function (badge) {
            if (badge.indexOf('[') > -1 && badge.indexOf(']') > -1) {
              // parse array
              let parsedBadge = JSON.parse(badge);
              if (parsedBadge.length) {
                badgeArr = badgeArr.concat(parsedBadge);
              }
            } else {
              badgeArr.push(badge);
            }
          });
          // unique badgeArr
          badgeArr = [...new Set(badgeArr)];
          badgeArr.forEach(function (badge) {
            let badgeHtml = `<div class="product-label-wrapper flex badge--new badge--custom">
                <span class="product-label product-label--custom" data-text="${badge.toLowerCase()}">
                  <span class="badge-text">${badge}</span>
                </span>
              </div>`;
            productSke.querySelector('.product-label-container').innerHTML += badgeHtml;
          });
        }

        productSke.querySelector('.card__quick-add .js-quick-add')?.setAttribute('data-product-url', productUrl);
        productSke.querySelector('.card__quick-add .quick-add-view-btn')?.setAttribute('href', productUrl);

        if (product.extraData?.strictStringifiedVariantData) {
          let variants = JSON.parse(product.extraData.strictStringifiedVariantData);
          if (variants && variants.length) {
            // sort variants by variant.title (size). Only sort if the title is digit. otherwise, keep default order
            variants.sort((a, b) => {
              let keyA = self.sizeSortKey(a.title, true);
              let keyB = self.sizeSortKey(b.title, true);

              if (keyA.category !== keyB.category) {
                return keyA.category - keyB.category;
              } else if (keyA.value !== keyB.value) {
                return keyA.value > keyB.value ? 1 : -1;
              }
              return 0;
            });
            let variantHtml = '';
            let isOnlyClass = variants.length == 1 ? 'is-only' : '';
            for (let i = 0; i < variants.length; i++) {
              if (variants[i].inventoryQuantity > 0) {
                let parsedTitle = variants[i].title.replace(/"/g, '&quot;').replace(/'/g, "&#39;");
                variantHtml += `<span class="product-card__size ${isOnlyClass}" data-title="${parsedTitle}">${variants[i].title}</span>`;
              }
            }
            productSke.querySelector('.product-card_sizes').innerHTML = `${variantHtml}`;

            if (variants.length == 1 && product.inStock) {
              let singleVariantId = variants[0].id.split('/').pop();
              if (singleVariantId) {
                productSke.querySelector('.js-quick-add').setAttribute('data-variant-id', singleVariantId);
                productSke.querySelector('.js-quick-add').classList.add('js-quick-add-variant');
              }
            }
          }
        }
      }

      return productSke;
    }

    modifyImageUrl(imageUrl, width) {
      // Check if the URL is from Shopify's CDN
      if (imageUrl.includes("cdn.shopify.com")) {
        // Construct the new URL with the desired size
        let newUrl = imageUrl.split('?')[0].replace(/(\.[^.]*)$/, `_${width}x${width}$1`) + '?' + imageUrl.split('?')[1];
        return newUrl;
      }
    }

    sizeSortKey(sizeTitle, noFallback = false) {
      const knownSizes = ["XXXS", "XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL"];
      const cmRegex = /^(\d+)\s?cm$/;
  
      // Check if the title is in the known sizes
      if (knownSizes.includes(sizeTitle)) {
        return { category: 0, value: knownSizes.indexOf(sizeTitle) };
      }
  
      // Check if the title is a number (only digits)
      if (/^\d+$/.test(sizeTitle)) {
        return { category: 1, value: parseInt(sizeTitle, 10) };
      }
  
      // Check if the title is a number followed by "cm"
      const cmMatch = sizeTitle.match(cmRegex);
      if (cmMatch) {
        return { category: 2, value: parseInt(cmMatch[1], 10) };
      }
  
      // For all other cases, treat as a string
      if (!noFallback) {
        return { category: 3, value: sizeTitle };
      } else {
        return { category: 4, value: 0 };
      }
    }

    /**
     * Render the filter from Hello Retail
     */
    async _renderSearchFilters() {
      if (this.data.filters) {
        let self = this;
        let data = this.data;
        let form = this._searchForm;
        let selector = this.selector;
        let filtersWrapper = form.querySelector(selector.filtersWrapper);
        filtersWrapper.innerHTML = '';
        let allFilters = data.filters;
        let filterOrder = [
          'extraDataList.shopBy',
          'extraDataList.gender',
          'extraDataList.PIMSizeAgeAgeList',
          'brand',
          'extraDataList.PIMSizeSizeList',
          'extraData.productType',
          'extraDataList.ProductFilterFilterText',
          'extraDataList.type',
          'price',
          'extraData.shoeWidth'
        ]
        // sort allFilters by filterOrder, if any filter inside allFilters is not in filterOrder, then push it to the end
        let sortedFilters = {};
        filterOrder.forEach(function (key) {
          if (allFilters[key]) {
            sortedFilters[key] = allFilters[key];
            delete allFilters[key];
          }
        });
        // add the rest of filters to the end
        for (let key in allFilters) {
          if (allFilters.hasOwnProperty(key)) {
            sortedFilters[key] = allFilters[key];
          }
        }
        for (let key in sortedFilters) {
          if (sortedFilters.hasOwnProperty(key)) {
            let filterTitle = key;

            for (let key2 in data.filter_titles) {
              if (data.filter_titles.hasOwnProperty(key2)) {
                if (key2 === key) {
                  filterTitle = data.filter_titles[key2];
                }
              }
            };

            let filterSke = form.querySelector(selector.filterSke).cloneNode(true);
            filterSke.querySelector('.hr-filter').setAttribute('data-filter', key);
            filterSke.querySelector('.hr-filter-heading').innerText = filterTitle;
            if (window.theme.settings.helloretailSearchOnFilterList && window.theme.settings.helloretailSearchOnFilterList.length) {
              if (window.theme.settings.helloretailSearchOnFilterList.includes(key) && filterSke.querySelector('.search-facet-search')) {
                filterSke.querySelector('.search-facet-search').classList.remove('hidden');
              }
            }

            let dropdownContent = '';
            if (key == 'price') {
              //dropdownContent = `<p data-min="${sortedFilters[key].min}" data-max="${sortedFilters[key].max}">range</p>`;
              // let minPrice = Math.floor(parseFloat(sortedFilters[key].min));
              let maxPrice = Math.floor(parseFloat(sortedFilters[key].max));
              let selectedMin = 0;
              let selectedMax = maxPrice;
              if (sortedFilters[key].selectedMin) {
                selectedMin = Math.floor(parseFloat(sortedFilters[key].selectedMin));
              }
              if (sortedFilters[key].selectedMax) {
                selectedMax = Math.floor(parseFloat(sortedFilters[key].selectedMax));
              }
              if (sortedFilters[key].selectedMin || sortedFilters[key].selectedMax) {
                filterSke.querySelector('.hr-filter-heading').innerHTML += `<span>1</span>`;
              }

              let priceSke = form.querySelector(selector.priceSke).cloneNode(true);
              priceSke.querySelector('.range-min').setAttribute('max', maxPrice);
              priceSke.querySelector('.range-min').setAttribute('value', selectedMin);
              priceSke.querySelector('.range-max').setAttribute('max', maxPrice);
              priceSke.querySelector('.range-max').setAttribute('value', selectedMax);
              priceSke.querySelector('.field-price-min').setAttribute('max', maxPrice);
              priceSke.querySelector('.field-price-min').setAttribute('value', selectedMin);
              priceSke.querySelector('.field-price-min').setAttribute('placeholder', 0);
              priceSke.querySelector('.field-price-max').setAttribute('max', maxPrice);
              priceSke.querySelector('.field-price-max').setAttribute('value', selectedMax);
              priceSke.querySelector('.field-price-max').setAttribute('placeholder', maxPrice);
              dropdownContent = `<price-range class="price-range">${priceSke.innerHTML}</price-range>`;
            } else {
              let filterArr = sortedFilters[key];
              if (key == 'extraDataList.PIMSizeSizeList') {
                // sort filter values by XXXS, XXS, XS, S, M, L, XL, XXL, XXXL, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9..
                filterArr.sort((a, b) => {
                  let keyA = self.sizeSortKey(a.title);
                  let keyB = self.sizeSortKey(b.title);
    
                  if (keyA.category !== keyB.category) {
                    return keyA.category - keyB.category;
                  } else if (keyA.value !== keyB.value) {
                    return keyA.value > keyB.value ? 1 : -1;
                  }
                  return 0;
                });
              } else if (key == 'extraDataList.PIMSizeAgeAgeList') {
                const config = {
                  monthUnit: window.theme.strings.helloretailMonthUnit || "mdr",
                  yearUnit: window.theme.strings.helloretailYearUnit || "år",
                  firstItem: window.theme.strings.helloretailFirstItem || "Præmature",
                  lastItem: window.theme.strings.helloretailLastItem || "Voksen"
                };

                filterArr.sort((a, b) => {
                  const aTitle = a.title
                  const bTitle = b.title
                  if (aTitle === config.firstItem) return -1;
                  if (bTitle === config.firstItem) return 1;
                  if (aTitle === config.lastItem) return 1;
                  if (bTitle === config.lastItem) return -1;

                  let aValue = parseInt(aTitle, 10);
                  let bValue = parseInt(bTitle, 10);
                  let aUnit = aTitle.indexOf(config.monthUnit) > -1 ? config.monthUnit : config.yearUnit;
                  let bUnit = bTitle.indexOf(config.monthUnit) > -1 ? config.monthUnit : config.yearUnit;

                  if (aUnit === bUnit) {
                    return aValue - bValue;
                  }
                  return aUnit === config.monthUnit ? -1 : 1;
                });
              } else {
                // sort filter values by alphabet
                filterArr.sort(function(a, b) {
                  let titleA = a.title.toUpperCase();
                  let titleB = b.title.toUpperCase();
                  if (titleA < titleB) {
                    return -1;
                  }
                  if (titleA > titleB) {
                    return 1;
                  }
                  return 0;
                });
              }

              let currentFiltersCount = 0;
              filterArr.forEach(function(filter) {
                if (filter.selected) {
                  currentFiltersCount++;
                }
                let filterTitle = filter.title;
                if (filterTitle.toLowerCase() == 'true') {
                  filterTitle = window.theme.strings.filterOptionTrue;
                } else if (filterTitle.toLowerCase() == 'false') {
                  filterTitle = window.theme.strings.filterOptionFalse;
                }
                if (key == 'hierarchies' && filterTitle.endsWith('$')) {
                  filterTitle = filterTitle.replace(/.$/g, '');
                }
                dropdownContent += `<li data-query="${filter.query}" class="${filter.selected?'selected':''}">${filterTitle}</li>`;
              });
              if (currentFiltersCount) {
                filterSke.querySelector('.hr-filter-heading').innerHTML += `<span>${currentFiltersCount}</span>`;
              }
            }
            filterSke.querySelector('.hr-filter-dropdown-content').innerHTML += `<ul>${dropdownContent}</ul>`;
            filtersWrapper.appendChild(filterSke);

            // filter when submit price range
            form.querySelector('.hr-price-submit').addEventListener('click', function(e) {
              e.preventDefault();
              form.querySelector('.hr-price-submit').classList.add('loading');
              self.getResults(self.searchTerm);
            });

            // toggle filter dropdown when click on filter heading
            filterSke.querySelector('.hr-filter .hr-filter-heading').addEventListener('click', function(e) {
              e.preventDefault();
              e.target.closest('.hr-filter').classList.toggle('active');
              // remove class active from other filters
              form.querySelectorAll('.hr-filter').forEach(function(filter) {
                if (filter !== e.target.closest('.hr-filter')) {
                  filter.classList.remove('active');
                }
              });
            });

            // do filter when click on filter item
            filterSke.querySelectorAll('.hr-filter-dropdown-content li').forEach(function(filterItem) {
              filterItem.addEventListener('click', function(e) {
                e.preventDefault();
                this.classList.toggle('selected');
                self.getResults(self.searchTerm);
              });
            });

            // search inside filter
            if (filterSke.querySelector('.search-facet-search')) {
              filterSke.querySelector('.search-facet-search').addEventListener('input', debounce(function(e) {
                let searchValue = e.target.value.toLowerCase();
                filterSke.querySelectorAll('.hr-filter-dropdown-content li').forEach(function(filterItem) {
                  if (filterItem.innerText.toLowerCase().indexOf(searchValue) > -1) {
                    filterItem.classList.remove('hidden');
                  } else {
                    filterItem.classList.add('hidden');
                  }
                });
              }), 200);
            }
          }
        }
        // append sort dropdown
        let sortSke = form.querySelector('.hr-sort-skeleton li').cloneNode(true);

        filtersWrapper.appendChild(sortSke);
        if (self.currentSearchSort.length) {
          sortSke.querySelectorAll('.hr-search-sort-option').forEach(function(sortItem) {
            if (self.currentSearchSort.includes(sortItem.getAttribute('data-value'))) {
              sortItem.classList.add('selected');
            }
          });
        } else {
          sortSke.querySelector('.hr-search-sort-option[data-value="most-popular"]').classList.add('selected');
        }
        
        // toggle filter dropdown when click on filter heading
        sortSke.querySelector('.hr-filter .hr-filter-heading').addEventListener('click', function(e) {
          e.preventDefault();
          e.target.closest('.hr-filter').classList.toggle('active');
          // remove class active from other filters
          form.querySelectorAll('.hr-filter').forEach(function(filter) {
            if (filter !== e.target.closest('.hr-filter')) {
              filter.classList.remove('active');
            }
          });
        });

        // do filter when click on sort item
        sortSke.querySelectorAll('.hr-filter-dropdown-content li').forEach(function(sortItem) {
          sortItem.addEventListener('click', function(e) {
            e.preventDefault();
            // remove selected on siblings
            this.parentNode.querySelectorAll('li').forEach(function(sibling) {
              sibling.classList.remove('selected');
            });
            this.classList.add('selected');
            self.getResults(self.searchTerm);
          });
        });
      }
    }

    /**
     * Show/hide filters mobile
     */
    _toggleMobileFilters() {
      this.querySelector('.hr-filters')?.classList.toggle('active');
      this.querySelector('.hr-filters-toggle-mobile')?.classList.toggle('active');
    }

    /**
     * Toggle mobile categories show more/less
     */
    _toggleMobileCategories() {
      const form = this._searchForm;
      const selector = this.selector;
      const categoriesWrapper = form.querySelector(selector.categoriesWrapper);
      const showMoreWrapper = form.querySelector(selector.categoryShowMoreWrapper);
      const showMoreText = form.querySelector(selector.showMoreText);
      const showLessText = form.querySelector(selector.showLessText);

      // Debug logging
      console.log('Toggle mobile categories called');
      console.log('Categories wrapper:', categoriesWrapper);
      console.log('Current expanded state:', this.categoriesExpanded);
      
      const categoryItems = categoriesWrapper.querySelectorAll('li');
      console.log('Found category items:', categoryItems.length);

      this.categoriesExpanded = !this.categoriesExpanded;

      if (this.categoriesExpanded) {
        // Show all categories
        categoryItems.forEach((item, index) => {
          if (index >= 4) {
            console.log(`Showing category ${index}:`, item);
            item.classList.remove('hidden');
          }
        });
        showMoreText.classList.add('hidden');
        showLessText.classList.remove('hidden');
      } else {
        // Hide categories beyond the first 4
        categoryItems.forEach((item, index) => {
          if (index >= 4) {
            console.log(`Hiding category ${index}:`, item);
            item.classList.add('hidden');
          }
        });
        showMoreText.classList.remove('hidden');
        showLessText.classList.add('hidden');
      }
    }

    formatMoney(cents, format = "") {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format;
      function defaultTo(value2, defaultValue) {
        return value2 == null || value2 !== value2 ? defaultValue : value2;
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ",");
        decimal = defaultTo(decimal, ".");
        if (isNaN(number) || number == null) {
          return 0;
        }
        number = (number / 100).toFixed(precision);
        let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
      }
      let value = "";
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_space_separator":
          value = formatWithDelimiters(cents, 2, " ", ".");
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'", ".");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_no_decimals_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 0, "'");
          break;
      }
      if (formatString.indexOf("with_comma_separator") !== -1) {
        return formatString.replace(placeholderRegex, value);
      } else {
        return formatString.replace(placeholderRegex, value);
      }
    }

    /**
     * Sets the live region loading state.
     */
    setLiveRegionLoadingState() {
      this.setLiveRegionText(this.loadingText);
    }

    /**
     * Sets the live region text.
     * @param {string} statusText - Status text.
     */
    setLiveRegionText(statusText) {
      this.statusEl.setAttribute('aria-hidden', 'false');
      this.statusEl.textContent = statusText;

      setTimeout(() => {
        this.statusEl.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    /**
     * Renders the results markup.
     * @param {string} resultsMarkup - Results markup.
     */
    renderResults(resultsMarkup) {
      this.results.innerHTML = resultsMarkup;
      this.setAttribute('results', true);
      this.open();
    }

    /**
     * Opens the results listbox.
     */
    open() {
      this.overlay.classList.add('is-visible');
      if (this.getQuery().length) this.resetBtn.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.setAttribute('open', '');

      document.body.classList.add('overlay-predictive-search');
      this.querySelector('.hello-retail-search-results')?.classList.remove('hidden');

      // Add event handlers (so the bound event listeners can be removed).
      this.keydownHandler = this.keydownHandler || this.handleKeydown.bind(this);
      this.keyupHandler = this.keyupHandler || this.handleKeyup.bind(this);
      this.resetBtnClickHandler = this.resetBtnClickHandler || this.close.bind(this);
      this.overlayClickHandler = this.overlayClickHandler || this.close.bind(this);

      // Add event listeners (for while results are open).
      this.addEventListener('keydown', this.keydownHandler);
      this.addEventListener('keyup', this.keyupHandler);
      this.resetBtn.addEventListener('click', this.resetBtnClickHandler);
      this.overlay.addEventListener('click', this.overlayClickHandler);
      if (this.closeRecomsBtn) {
        this.closeRecomsBtn.addEventListener('click', this.close.bind(this));
      }
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this.close.bind(this));
      }
    }

    /**
     * Closes the results listbox.
     * @param {object} evt - Event object.
     */
    close(evt) {
      this.querySelector('.hello-retail-search-results')?.classList.add('hidden');
      // If reset button was clicked, empty the input field.
      if (evt && evt.target === this.resetBtn) {
        this.input.value = '';
        this.removeAttribute('results');
        // this.input.focus();
      }

      // Deselect the selected result (if there is one).
      const selected = this.querySelector('.predictive-search__item[aria-selected="true"]');
      if (selected) selected.setAttribute('aria-selected', 'false');

      this.removeAttribute('open');
      this.resetBtn.hidden = true;
      this.overlay.classList.remove('is-visible');
      this.input.setAttribute('aria-activedescendant', '');
      this.input.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overlay-predictive-search');

      // Remove event listeners added on search results opening.
      this.removeEventListener('keydown', this.keydownHandler);
      this.resetBtn.removeEventListener('click', this.resetBtnClickHandler);
      this.overlay.removeEventListener('click', this.overlayClickHandler);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}
